import styles from './PageMulti.module.css'
import HeaderLogin from '../../Components/HeaderLogin'
import Header from '../../Components/Header'
import MultiMain from '../../Components/MultiMain'
import Loader from '../../Components/Loader'
import Footer from '../../Components/Footer'
import backgroundImage from '../../imgs/cloud-neon-vibe.png'
import { useContext, useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { DataContext } from '../../Components/DataContext'

function PageMulti() {
    
    const [optionMulti, setOptionMulti] = useState([]) // mapear todas as opções da página multi    
    const [optionMultiNumberId, setOptionMultiNumberId] = useState([]) // capturar o número e a ID da opção de múltipla escolha atual do componente MultiMain
    const [optNum1, setOptNum1] = useState('')
    const [optNum2, setOptNum2] = useState('')
    const [optNum3, setOptNum3] = useState('')
    const [optNum4, setOptNum4] = useState('')
    const [optNum5, setOptNum5] = useState('')
    const [answerDescriptionDisplay, setAnswerDescriptionDisplay] = useState(styles.invisibleAnswerDescription)
    const [descriptionDisplay, setDescriptionDisplay] = useState(styles.invisibleDescription)

    // pegando as variáveis através do 'useContext' do componente 'DataContext'
    const { listMultiQuestionsContext, listMultiQuestionsContextLength, listMultiOptionsContext, loading, setLoading } = useContext(DataContext)

    const [questionMulti, setQuestionMulti] = useState(listMultiQuestionsContext[Math.floor(Math.random() * listMultiQuestionsContextLength)]) // mostrar uma questão ao entrar na página Multi

    // pegando a variável booleana para habilitar ou desabilitar tudo quando tiver conectado ou não com a api usando 'useOutletContext()' da página base e o número random da questão anterior que foi respondida
    const { activePageFormsQuestionsOptions, setActivePageFormsQuestionsOptions, setActivePageMain, setActivePageMulti, setActivePageThreeMulti, 
        setActivePageDemo, loginValidate, setActivePageInfo, setActivePageQuizBuilder, setActivePauseTimer  } = useOutletContext()

    useEffect(() => {
        // tornar a página ativa ao entrar na rota dela e desativa as demais
        setActivePageMulti(true)

        setActivePageDemo(false)
        setActivePageMain(false)
        setActivePageThreeMulti(false)
        setActivePageFormsQuestionsOptions(false)
        setActivePageInfo(false)
        setActivePageQuizBuilder(false)

        setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial

    }, [setActivePageMulti, setActivePageDemo, setActivePageMain, setActivePageThreeMulti, setActivePageFormsQuestionsOptions, setActivePageInfo, 
        setActivePageQuizBuilder, setActivePauseTimer])

    useEffect(() => {
        const randomNumbers = [] // armazena a lista de números randômicos para as opções

        // gerando um número para randomizar toda vez que renderizar
        while (randomNumbers.length < 5) { // o comprimento deve ser no máximo o número de opções disponíveis, neste caso '5'
            const random = Math.floor(Math.random() * 5)

            if (!randomNumbers.includes(random)) {
                randomNumbers.push(random)

            }

        }

        setOptNum1(randomNumbers[0])
        setOptNum2(randomNumbers[1])
        setOptNum3(randomNumbers[2])
        setOptNum4(randomNumbers[3])
        setOptNum5(randomNumbers[4])

    }, [])

    useEffect(() => { // mapeando todas as opções para procurar a opção que possue o mesmo número da questão e mostra-la na tela junto com a questão        
        // para garantir que todos os atributos sejam capturados antes de mostrar na tela e sejam 'opções' para a questão

        if (!listMultiQuestionsContext || !listMultiOptionsContext || !questionMulti) return     

        function questionMultiOptionMatch() { // função que procura uma questão com sua opção correspondente, evitando aparcer uma questão que não tenha opção
            let matchedQuestion = null
            let matchedOption = null

            setLoading(true) // habilita o componente 'Loader'

            // tenta corresponder diretamente com a questão atual
            matchedOption = listMultiOptionsContext
                            .filter(options => options.optionNumber !== '')
                            .find(option => { // retorna uma opção que tenha uma questão correspondente

                return ((option.optionNumber === questionMulti.questionNumber))

            })
     
            // Se não encontrou, tenta corresponder via lista de questões
            if (!matchedOption) { // se a opção não tiver questão correspondente, procura uma nova questão e opção correspondentes
                listMultiOptionsContext
                    .filter(options => options.optionNumber !== '')
                    .forEach(option => {
                        matchedQuestion = listMultiQuestionsContext
                            .filter(questions => questions.questionNumber !== '')
                            .find(question => { // retorna uma questão que tenha uma opção correspondente

                            return ((question.questionNumber === option.optionNumber))

                    })

                    if (matchedQuestion) { // se a questão tiver uma opção correspondente, captura a opção
                        matchedOption = option // armazena a opção correspondente
                        setQuestionMulti(matchedQuestion) // atualizando a questão
                        setLoading(false) // desabilita o componente 'Loader'
                        
                    }
                })

            } else if (matchedOption) { // se tiver opção, não precisa mudar a questão
                // atualizando a opção correspondente
                setOptionMulti([matchedOption.optionA, matchedOption.optionB, matchedOption.optionC, matchedOption.optionD, matchedOption.optionE]) // atualizando a opção
                setOptionMultiNumberId([matchedOption.optionNumber, matchedOption.id]) // capturar o número e o id da opção atual
                setLoading(false) // desabilita o componente 'Loader'

            } else {
                console.error('No option with a corresponding question was found. Create a new question or option using the same number to ensure proper mapping.')

            }

        }
        
        // chamando a função que busca uma questão e a opção correspondentes, com base na 'questionMulti' da página Multi
        questionMultiOptionMatch()

    }, [listMultiQuestionsContext, listMultiQuestionsContextLength, listMultiOptionsContext, questionMulti, setQuestionMulti, setOptionMulti, setOptionMultiNumberId, setLoading])

    return(
        <div>
            <div
                id='allQuestionsMultiId' 
                className={styles.allQuestionsMultiClass} 
                key={questionMulti.id}
            >
                {!loginValidate && 
                <>
                    <HeaderLogin />
                    <main className={styles.bgLogin}></main>

                </>}

                {/* background image */}
                {loginValidate && activePageFormsQuestionsOptions === false && 
                <img 
                    className={`backgroundImageClass ${styles.backgroundImage}`} 
                    src={backgroundImage} 
                    alt='backgoundIimage'
                />} 

                {loginValidate && 
                <>
                    <Header />

                    <MultiMain 
                        questionMulti={questionMulti}
                        setQuestionMulti={setQuestionMulti}
                        optionMulti={optionMulti}
                        optionMultiNumberId={optionMultiNumberId}
                        question={questionMulti.questionText}
                        iconDescription={questionMulti.iconDescription}
                        description={questionMulti.description}
                        questionNumber={questionMulti.questionNumber}
                        elementId={questionMulti.id}
                        answerDescriptionDisplay={answerDescriptionDisplay}
                        setAnswerDescriptionDisplay={setAnswerDescriptionDisplay}
                        descriptionDisplay={descriptionDisplay}
                        setDescriptionDisplay={setDescriptionDisplay}
                        optNum1={optNum1}
                        optNum2={optNum2}
                        optNum3={optNum3}
                        optNum4={optNum4}
                        optNum5={optNum5}
                    />
                
                </>
                }

                <Footer />
            
            </div>
            
            {loading && <Loader />}           
               
        </div>

    )
}

export default PageMulti
